import { useUser } from '@cibo/profile'
import { Outlet } from 'react-router-dom'

import { InvitedDialog } from './InvitedDialog'

export const HomeLayout = () => {
  const user = useUser()

  if (!user.data) {
    return null
  }

  return (
    <>
      <Outlet />
      <InvitedDialog />
    </>
  )
}
